// Custom theme configuration
// Cambiar en dist para probar
export const customTheme = {
    primaryColor: '#1890ff',
    primaryColorSoft: '#1890ff20',
    secondaryColor: '#004263',
    successColor: '#52c41a',
    warningColor: '#faad14',
    errorColor: '#f5222d',
    infoColor: '#1890ff',
    backgroundColor: '#F7F9FB',
    textColor: '#000000d9',
    borderColor: '#d9d9d9',
    selectedColor: '#E7450F',
    borderRadius: 6,
    fontSize: {
        small: '12px',
        medium: '14px',
        large: '16px',
        xlarge: '20px'
    },
    spacing: {
        xs: '4px',
        sm: '8px',
        md: '16px',
        lg: '24px',
        xl: '32px'
    }
};
export const applyCssVariables = (customTheme) => {
    const root = document.documentElement;
    root.style.setProperty('--ant-color-primary', customTheme.primaryColor);
    root.style.setProperty('--color-primary-soft', customTheme.primaryColorSoft);
    root.style.setProperty('--color-secondary', customTheme.secondaryColor);
    root.style.setProperty('--color-selected', customTheme.selectedColor);
    root.style.setProperty('--color-success', customTheme.successColor);
    root.style.setProperty('--color-warning', customTheme.warningColor);
    root.style.setProperty('--color-error', customTheme.errorColor);
};
// Ant Design theme configuration
export const createAntdTheme = (customTheme) => {
    return {
        cssVar: true,
        token: {
            // Primary colors
            colorPrimary: customTheme.primaryColor,
            colorSuccess: customTheme.successColor,
            colorWarning: customTheme.warningColor,
            colorError: customTheme.errorColor,
            colorInfo: customTheme.infoColor,
            // Background colors
            colorBgBase: customTheme.backgroundColor,
            colorBgContainer: '#ffffff',
            colorBgElevated: '#ffffff',
            colorBgLayout: '#f5f5f5',
            colorBgSpotlight: '#ffffff',
            // Text colors
            colorText: customTheme.textColor,
            colorTextSecondary: '#00000073',
            colorTextTertiary: '#00000040',
            colorTextQuaternary: '#00000026',
            // Border
            colorBorder: customTheme.borderColor,
            colorBorderSecondary: '#f0f0f0',
            borderRadius: customTheme.borderRadius,
            // Font
            fontSize: 14,
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
            // Spacing
            padding: 16,
            margin: 16,
            // Layout
            sizeUnit: 4,
            sizeStep: 4,
            // Motion
            motionDurationFast: '0.1s',
            motionDurationMid: '0.2s',
            motionDurationSlow: '0.3s',
            // Z-index
            zIndexBase: 0,
            zIndexPopupBase: 1000,
            // Screen breakpoints
            screenXS: 480,
            screenSM: 576,
            screenMD: 768,
            screenLG: 992,
            screenXL: 1200,
            screenXXL: 1600,
        },
        components: {
            // Layout components
            Layout: {
                headerBg: '#001529',
                headerHeight: 64,
                headerPadding: '0 24px',
                siderBg: '#001529',
                triggerBg: '#002140',
                triggerColor: '#ffffff',
                zeroTriggerWidth: 36,
                zeroTriggerHeight: 42,
            },
            // Menu component
            Menu: {
                darkItemBg: '#001529',
                darkItemColor: '#ffffff73',
                darkItemHoverBg: '#1890ff',
                darkItemHoverColor: '#ffffff',
                darkItemSelectedBg: '#1890ff',
                darkItemSelectedColor: '#ffffff',
                darkSubMenuItemBg: '#000c17',
                itemHeight: 40,
                collapsedWidth: 80,
            },
            // Button component
            Button: {
                borderRadius: customTheme.borderRadius,
                controlHeight: 32,
                controlHeightLG: 40,
                controlHeightSM: 24,
            },
            // Form components
            Form: {
                labelFontSize: 14,
                labelColor: customTheme.textColor,
                itemMarginBottom: 24,
                verticalLabelPadding: '0 0 8px',
            },
            Input: {
                borderRadius: customTheme.borderRadius,
                controlHeight: 32,
                controlHeightLG: 40,
                controlHeightSM: 24,
            },
            Select: {
                borderRadius: customTheme.borderRadius,
                controlHeight: 32,
                controlHeightLG: 40,
                controlHeightSM: 24,
            },
            // Table component
            Table: {
                headerBg: '#fafafa',
                headerColor: customTheme.textColor,
                headerSortActiveBg: '#f2f2f2',
                headerSortHoverBg: '#f2f2f2',
                bodySortBg: '#fafafa',
                rowHoverBg: '#f5f5f5',
                rowSelectedBg: '#e6f7ff',
                rowSelectedHoverBg: '#bae7ff',
                cellPaddingBlock: 16,
                cellPaddingInline: 16,
                borderRadius: customTheme.borderRadius,
            },
            // Card component
            Card: {
                borderRadius: customTheme.borderRadius,
                headerBg: 'transparent',
                headerFontSize: 16,
                headerFontSizeSM: 14,
                headerHeight: 56,
                headerHeightSM: 36,
                actionsBg: '#fafafa',
                actionsLiMargin: '12px 0',
                tabsMarginBottom: 16,
            },
            // Modal component
            Modal: {
                borderRadius: customTheme.borderRadius,
                headerBg: '#ffffff',
                contentBg: '#ffffff',
                footerBg: 'transparent',
                titleFontSize: 16,
                titleLineHeight: 1.5,
            },
            // Notification component
            Notification: {
                borderRadius: customTheme.borderRadius,
            },
            // Message component
            Message: {
                borderRadius: customTheme.borderRadius,
                contentPadding: '10px 16px',
                contentBg: '#ffffff',
            },
            // Steps component
            Steps: {
                navArrowColor: customTheme.primaryColor,
                titleLineHeight: 1.5,
                customIconSize: 32,
                customIconTop: 0,
                customIconFontSize: 24,
                iconSize: 32,
                iconSizeSM: 24,
                dotSize: 8,
                dotCurrentSize: 10,
            },
            // Progress component
            Progress: {
                defaultColor: customTheme.primaryColor,
                remainingColor: '#f5f5f5',
                circleTextColor: customTheme.textColor,
                lineBorderRadius: 100,
            },
            // Badge component
            Badge: {
                indicatorHeight: 20,
                indicatorHeightSM: 16,
                dotSize: 6,
                textFontSize: 12,
                textFontSizeSM: 12,
                textFontWeight: 'normal',
                statusSize: 6,
            },
            // Avatar component
            Avatar: {
                borderRadius: customTheme.borderRadius,
                groupOverlapping: -8,
                groupSpace: 3,
                containerSize: 32,
                containerSizeLG: 40,
                containerSizeSM: 24,
                textFontSize: 18,
                textFontSizeLG: 24,
                textFontSizeSM: 14,
            },
            // Pagination component
            Pagination: {
                borderRadius: customTheme.borderRadius,
                itemSize: 32,
                itemSizeSM: 24,
                itemActiveBg: customTheme.backgroundColor,
                itemLinkBg: '#ffffff',
                itemInputBg: '#ffffff',
                miniOptionsSizeChangerTop: 0,
            },
            // Breadcrumb component
            Breadcrumb: {
                lastItemColor: customTheme.textColor,
                fontSize: 14,
                iconFontSize: 12,
                linkColor: customTheme.primaryColor,
                linkHoverColor: '#40a9ff',
                separatorColor: '#00000040',
                separatorMargin: 8,
            },
            // Tabs component
            Tabs: {
                borderRadius: customTheme.borderRadius,
                titleFontSize: 14,
                titleFontSizeLG: 16,
                titleFontSizeSM: 14,
                inkBarColor: customTheme.primaryColor,
                itemColor: customTheme.textColor,
                itemSelectedColor: customTheme.primaryColor,
                itemHoverColor: '#40a9ff',
                itemActiveColor: '#096dd9',
                cardBg: '#fafafa',
                cardHeight: 40,
                cardPadding: '8px 16px',
                cardPaddingSM: '6px 12px',
                cardPaddingLG: '12px 20px',
                horizontalMargin: '0 0 16px 0',
                horizontalItemGutter: 32,
                horizontalItemMargin: '0 0 16px 0',
                horizontalItemMarginRTL: '0 0 16px 0',
                horizontalItemPadding: '12px 0',
                horizontalItemPaddingSM: '8px 0',
                horizontalItemPaddingLG: '16px 0',
                verticalItemPadding: '8px 24px',
                verticalItemMargin: '0 0 4px 0',
                cardGutter: 2,
            }
        },
        algorithm: undefined, // Can be theme.darkAlgorithm for dark mode
    };
};
// Insurance-specific color palette
export const insuranceColors = {
    // Status colors
    policyActive: '#52c41a',
    policyExpired: '#faad14',
    policyCancelled: '#f5222d',
    policyPending: '#1890ff',
    // Claim status colors
    claimReported: '#1890ff',
    claimUnderReview: '#faad14',
    claimApproved: '#52c41a',
    claimRejected: '#f5222d',
    claimClosed: '#8c8c8c',
    // Payment status colors
    paymentPending: '#faad14',
    paymentPaid: '#52c41a',
    paymentOverdue: '#f5222d',
    paymentCancelled: '#8c8c8c',
    paymentRefunded: '#722ed1',
    // Insurance type colors
    autoInsurance: '#1890ff',
    homeInsurance: '#52c41a',
    lifeInsurance: '#722ed1',
    healthInsurance: '#fa8c16',
    // Priority colors
    high: '#f5222d',
    medium: '#faad14',
    low: '#52c41a',
    // Background colors
    lightBlue: '#e6f7ff',
    lightGreen: '#f6ffed',
    lightRed: '#fff2f0',
    lightYellow: '#fffbe6',
    lightPurple: '#f9f0ff',
    lightGray: '#fafafa',
};
// Responsive breakpoints - Mobile First Approach
export const breakpoints = {
    xs: '(max-width: 575px)',
    sm: '(min-width: 576px) and (max-width: 767px)',
    md: '(min-width: 768px) and (max-width: 991px)',
    lg: '(min-width: 992px) and (max-width: 1199px)',
    xl: '(min-width: 1200px) and (max-width: 1599px)',
    xxl: '(min-width: 1600px)',
    // Utility breakpoints
    mobile: '(max-width: 767px)',
    tablet: '(min-width: 768px) and (max-width: 991px)',
    desktop: '(min-width: 992px)',
    // Touch device detection
    touch: '(hover: none) and (pointer: coarse)',
    hover: '(hover: hover) and (pointer: fine)',
};
// Responsive spacing system
export const responsiveSpacing = {
    xs: {
        padding: '8px',
        margin: '8px',
        gap: '8px',
    },
    sm: {
        padding: '12px',
        margin: '12px',
        gap: '12px',
    },
    md: {
        padding: '16px',
        margin: '16px',
        gap: '16px',
    },
    lg: {
        padding: '24px',
        margin: '24px',
        gap: '24px',
    },
    xl: {
        padding: '32px',
        margin: '32px',
        gap: '32px',
    },
};
// Touch target sizes (minimum 44px for accessibility)
export const touchTargets = {
    minimum: '44px',
    comfortable: '48px',
    large: '56px',
};
// Common CSS-in-JS styles
export const commonStyles = {
    flexCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    flexBetween: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
    },
    textEllipsis: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    shadow: {
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    },
    borderRadius: {
        borderRadius: customTheme.borderRadius,
    },
    fullWidth: {
        width: '100%',
    },
    fullHeight: {
        height: '100%',
    },
    noMargin: {
        margin: 0,
    },
    noPadding: {
        padding: 0,
    },
};
export default {
    customTheme,
    createAntdTheme,
    insuranceColors,
    breakpoints,
    commonStyles,
};
